import React, { useEffect } from "react";
import momentTz from "moment-timezone";
import { Layout } from "core/components/Layout";
import { useCurrentUserTimezone } from "core/hooks/useCurrentTimeZone";
import { useAppSelector } from "core/store";
import { ReportTypePicker } from "reports/components/ReportTypePicker";
import { ReportsBuildingView } from "reports/components/ReportsBuildingView";
import { ReportsFilters } from "reports/components/ReportsFilters";
import { ReportsHeader } from "reports/components/ReportsHeader";
import { ReportsIndividualsView } from "reports/components/ReportsIndividualsView";
import {
  ReportType,
  getReportsDateRange,
  setDateEndAt,
  setDateStartAt,
} from "reports/slice";

export const ReportsView = () => {
  const timezone = useCurrentUserTimezone();
  const todayDate = momentTz.tz(timezone);
  const todayDateRange = getReportsDateRange(todayDate);

  const reportType = useAppSelector(state => state.reports.reportType);

  useEffect(() => {
    if (timezone) {
      setDateStartAt(todayDateRange.startAt);
      setDateEndAt(todayDateRange.endAt);
    }
  }, [timezone]);

  return (
    <Layout
      pageSubheader={
        <ReportsHeader>
          <ReportTypePicker />
          <ReportsFilters />
        </ReportsHeader>
      }
      pageTitle="Reporting"
    >
      {reportType === ReportType.Buildings ? (
        <ReportsBuildingView />
      ) : (
        <ReportsIndividualsView />
      )}
    </Layout>
  );
};
